import React from "react";
import NewsCarsoul from "./NewsCarsoul";
import { newsData } from "./newsData";
import NewsCard from "./NewsCard";
import PageTitleCard from "../../templates/PageTitleCard";
import PageHeading from "../../../templates/PageHeading";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import { useQuery } from "react-query";
import FixedFooter from "../../templates/FixedFooter";
import UserHeader from "../../../components/header/UserHeader";
import BackHome from "../../../templates/BackHome";
import SubHeadingText from "../../../common/SubHeadingText";
import RightArrow from "../../../templates/RightArrow";
import CurrentPath from "../../../templates/CurrentPath";

const NewsSection = () => {
  const { data,isLoading } = useQuery({
    queryKey: "getAllnewscard",
    queryFn: () =>
      axios.get(`${BASEURL}newsroom`).then((res) => {
        return res?.data;
      }),
  });

  return (
    <div>
      <PageTitleCard>
        <PageHeading>News Section</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>News Section</CurrentPath>
        </div>
      </PageTitleCard>

      <div className="container mx-auto py-8 max-sm:px-8">
        <SubHeadingText>News Section</SubHeadingText>
        <div className="py-8 ">
        <NewsCarsoul />
        <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 max-sm:grid-cols-1 gap-5 my-4 mx-auto md:px-4 ">
          {data?.data?.map((v, i) => {
            return (
              <NewsCard
                key={i}
                title={v.heading}
                img={v.image_url}
                descrpition={v.description}
              />
            );
          })}
        </div>
      </div>
      </div>

    
    </div>
  );
};

export default NewsSection;
